const DAY_LABELS = ["S", "M", "T", "W", "T", "F", "S"];

function intensityClass(day) {
  if (!day || !day.active) return "bg-gray-100";
  if (day.videos_completed >= 3) return "bg-blue-600";
  if (day.videos_completed >= 2) return "bg-blue-500";
  return "bg-blue-400";
}

function formatDayNumber(dateStr) {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";
  return String(parseInt(parts[2], 10));
}

function ActivityHeatmap({ activityHeatmap }) {
  if (!activityHeatmap || activityHeatmap.length === 0) {
    return null;
  }

  // Take the most recent 28 days (4 weeks)
  const last28 = activityHeatmap.slice(-28);

  // Align so that the first day in the grid falls under its correct weekday column.
  const firstDate = new Date(last28[0].date + "T00:00:00");
  const leadingBlanks = firstDate.getDay();
  const cells = [...Array(leadingBlanks).fill(null), ...last28];
  // Pad trailing blanks to fill a 4x7 = 28 grid (or more rows if needed)
  const rowCount = Math.ceil(cells.length / 7);
  while (cells.length < rowCount * 7) cells.push(null);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5">
      <h2 className="text-lg font-bold text-gray-800 mb-4">
        Activity (last 4 weeks)
      </h2>

      {/* Weekday header */}
      <div className="grid grid-cols-7 gap-1.5 mb-1.5">
        {DAY_LABELS.map((label, idx) => (
          <div
            key={idx}
            className="text-center text-[10px] font-medium text-gray-400 uppercase"
          >
            {label}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7 gap-1.5">
        {cells.map((day, idx) => {
          if (!day) {
            return <div key={idx} className="aspect-square" />;
          }
          const count = day.videos_completed || 0;
          return (
            <div
              key={idx}
              className={`aspect-square rounded-md flex items-center justify-center text-[11px] font-medium ${intensityClass(day)} ${day.active ? "text-white" : "text-gray-400"}`}
              title={`${day.date}: ${count} video${count !== 1 ? "s" : ""}`}
            >
              {formatDayNumber(day.date)}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex items-center gap-3 mt-4 text-xs text-gray-400">
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-sm bg-gray-100" />
          <span>Inactive</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-sm bg-blue-400" />
          <span>1 video</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-sm bg-blue-500" />
          <span>2 videos</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-sm bg-blue-600" />
          <span>3+</span>
        </div>
      </div>
    </div>
  );
}

export default ActivityHeatmap;
